import { dsLogger } from '../../shared/services/logger/logger.instance';

export const modalLogger = dsLogger.extend('modal');
